import {Utils} from '@astek/utils';
import {JsonConfigInterface} from './json-config-interface';
import {PressureUnitEnum} from '../state/pressure-unit.enum';

export type PressureConfigJson =  {
  mmHg: number;
  cmH2o: number;
};

export class PressureConfig implements JsonConfigInterface<PressureConfigJson> {

  private _mmHg: number = 0;
  private _cmH2o: number = 0;

  constructor(json?: PressureConfigJson) {
    if (!Utils.isNullOrUndefined(json)) {
      this.deserializeJson(json);
    }
  }

  public get mmHg(): number {
    return this._mmHg;
  }

  public get cmH2o(): number {
    return this._cmH2o;
  }

  public deserializeJson(json: PressureConfigJson): void {
    this._mmHg = json.mmHg;
    this._cmH2o = json.cmH2o;
  }

  public fromUnit(unit: PressureUnitEnum): number {
    switch (unit) {
      case PressureUnitEnum.MM_HG:
        return this._mmHg;
      case PressureUnitEnum.CM_H2O:
        return this._cmH2o;
      default:
        throw new Error(`Unhandled pressure unit '${Utils.enumName(unit, PressureUnitEnum)}'`);
    }
  }
}
